import { gql } from '@apollo/client';

export const ARCHIVE_PROGRAMME = gql`
  mutation archiveProgramme($id: ID!) {
    programme: archiveProgramme(id: $id) {
      id
      name
    }
  }
`;
